import { FC } from 'react';

import { SetLocation } from 'src/general/components/SetLocationPopup/EnterLocationScreen/SetLocation/SetLocation';
import { PopUpTitle } from 'src/general/components/SetLocationPopup/PopUpTitle/PopUpTitle';

import { SetLocationPopupMicrocopyProps } from '../SetLocationPopup.types';

export type EnterLocationScreenProps = {
  microcopy: SetLocationPopupMicrocopyProps;
  open: boolean;
  onClose: () => void;
  onChange: (value: any) => void;
};

export const EnterLocationScreen: FC<EnterLocationScreenProps> = ({ microcopy, onClose, onChange }) => {
  const { titleStart } = microcopy;

  return (
    <>
      <PopUpTitle title={titleStart} onClose={onClose} />
      <SetLocation microcopy={microcopy} onChange={onChange} />
    </>
  );
};
